import { useCallback } from 'react';
import { useFeatureFlagOverrides } from '@/lib/providers/featureFlagOverrideContext';
import { isDevToolsEnabled } from '@/lib/utils/dev-tools/isDevToolsEnabled';
import { FeatureFlagDevToolsDialog } from './FeatureFlagDevToolsDialog';
import { FeatureFlagOverrideBadge } from './FeatureFlagOverrideBadge';
import { useDevToolsShortcut } from './useDevToolsShortcut';

/**
 * Main component that orchestrates the feature flag dev tools.
 * Renders the badge and dialog, handles keyboard shortcuts.
 */
export const FeatureFlagDevTools: React.FC = () => {
  const { isDialogOpen, setIsDialogOpen } = useFeatureFlagOverrides();

  const toggleDialog = useCallback(() => {
    setIsDialogOpen((prev) => !prev);
  }, [setIsDialogOpen]);

  // Set up keyboard shortcut
  useDevToolsShortcut(toggleDialog);

  // Only render in dev/staging environments
  if (!isDevToolsEnabled()) {
    return null;
  }

  return (
    <>
      <FeatureFlagOverrideBadge onClick={toggleDialog} />
      {isDialogOpen && <FeatureFlagDevToolsDialog open={true} onOpenChange={setIsDialogOpen} />}
    </>
  );
};
